import { render, staticRenderFns } from "./MyPagesSimpleLayout.vue?vue&type=template&id=c8937922"
import script from "./MyPagesSimpleLayout.vue?vue&type=script&lang=js"
export * from "./MyPagesSimpleLayout.vue?vue&type=script&lang=js"
import style0 from "./MyPagesSimpleLayout.vue?vue&type=style&index=0&id=c8937922&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports